import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FloatingLabelInput from '../../components/FloatingLabelInput';
import UtilsService from '../../../services/UtilsService';
import { varietyPropType } from './Varieties';
import { speciePropType } from '../species/Species';
import FormModal from '../../components/FormModal';
import FormService from '../../../services/FormService';

export const fields = [
  {
    id: 'description',
    label: 'Descrição',
    type: 'text',
    field: 'description',
    validations: [
      (v) => !!v || 'Descrição é obrigatória',
    ],
    autoFocus: true,
    required: true,
  },
  {
    id: 'averageGermination',
    label: 'Germinação média',
    type: 'number',
    field: 'average_germination',
    validations: [
    ],
  },
  {
    id: 'plantingEfficiency',
    label: 'Eficiência de plantio',
    type: 'number',
    field: 'planting_efficiency',
    validations: [
    ],
  },
  {
    id: 'specie',
    label: 'Atividade',
    type: 'autocomplete',
    field: 'specie_id',
    validations: [
      (v) => !!v || 'Atividade é obrigatória',
    ],
    required: true,
    renderLabel: ({ description }) => description,
  },
  {
    id: 'maturation',
    label: 'Maturação',
    type: 'text',
    field: 'maturation',
  },
  {
    id: 'fantasyName',
    label: 'Nome fantasia',
    type: 'text',
    field: 'fantasy_name',
  },
];

const emptyState = {
  description: '',
  averageGermination: 0,
  plantingEfficiency: 0,
  specie: null,
  maturation: '',
  fantasyName: '',
};

export const buildVariety = (variety) => {
  if (FormService.hasData) {
    return FormService.data;
  }

  if (variety) {
    const {
      description, averageGermination, plantingEfficiency, specie, maturation, fantasyName,
    } = variety;
    return {
      description,
      averageGermination,
      plantingEfficiency,
      specie,
      maturation: maturation || '',
      fantasyName: fantasyName || '',
    };
  }

  return emptyState;
};


const EditVarietyModal = (props) => {
  const {
    routes, variety, species,
  } = props;
  const urlVarieties = routes.varietiesPath;

  const values = {
    specie: species,
  };

  const [state, setState] = useState(() => buildVariety(variety));
  const [open, setOpen] = useState(true);
  const [edit] = useState(!!variety);

  const validInputs = () => UtilsService.validateState(fields, state);

  const handleChange = (id, value) => {
    setState({
      ...state,
      [id]: value,
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onFormSubmit = () => { FormService.data = state; };

  const getUrlForm = () => {
    if (edit) {
      const path = routes.varietyPath;
      return path.replace(':id', variety.id);
    }

    return urlVarieties;
  };

  return (
    <>
      <FormModal
        open={open}
        title="Cultivar"
        formForProps={{
          url: getUrlForm(),
          method: edit ? 'put' : 'post',
          onSubmit: onFormSubmit,
        }}
        actionsButtons={{
          confirm: {
            label: 'Salvar',
            disabled: !validInputs(),
          },
          cancel: {
            onClick: handleClose,
          },
        }}
      >
        {fields.map(({
          id,
          label,
          type,
          field,
          validations,
          placeholder,
          format,
          required,
          autoFocus,
          renderLabel,
        }) => (
          <FloatingLabelInput
            key={field}
            id={id}
            label={label}
            type={type}
            validationRules={validations}
            value={state[id]}
            onChange={handleChange}
            name={field}
            placeholder={placeholder}
            format={format}
            required={required}
            autoFocus={autoFocus}
            renderLabel={renderLabel}
            values={values[id]}
          />
        ))}
      </FormModal>
    </>
  );
};

EditVarietyModal.propTypes = {
  variety: varietyPropType,
  routes: PropTypes.objectOf(PropTypes.string),
  species: PropTypes.arrayOf(speciePropType).isRequired,
};

export default EditVarietyModal;
